(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        // In always sticky mode, scrolled-past-header might be handled differently
        // by CSS or is always intended to be present. We'll add it here
        // assuming it's part of the "always sticky" visual state.
        // If your theme relies purely on scroll position for this class even in
        // always-sticky, you might remove this line.
         this.header.classList.add('shopify-section-header-sticky');
         if (!this.header.classList.contains('scrolled-past-header')) {
            this.header.classList.add('scrolled-past-header');
         }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // --- Start: Add Hover Logic ---
      // Initialize hover state flag
      this.isMenuHovered = false;

      // Select elements that contain the navigation links within the header.
      // Adjust the selector if needed based on your theme's HTML structure.
      // Common selectors: 'nav', '.header__inline-menu', 'header-menu', '.site-nav'
      // Using 'header-menu' and '.site-nav' as potential common options.
      this.navMenus = this.header.querySelectorAll('sticky-header'); // <-- Adjusted Selector

      if (this.navMenus.length > 0) {
        // Define event handlers using arrow functions to maintain 'this' context
        this.handleMouseEnter = () => {
          this.isMenuHovered = true;
          // Add 'scrolled-past-header' class on hover
          this.header.classList.add('scrolled-past-header');
          // Also ensure sticky state is applied if not always sticky
          if (!this.headerIsAlwaysSticky) {
             this.header.classList.add('shopify-section-header-sticky');
             // Optionally add 'animate' if that class is needed for the sticky transition visual
             this.header.classList.add('animate');
             // Optionally remove 'hidden' if the hover should reveal the header
             this.header.classList.remove('shopify-section-header-hidden');
          }
        };

        this.handleMouseLeave = () => {
          this.isMenuHovered = false;
          // Check if the header is *actually* scrolled past the threshold independently of hover
          // Use headerBounds.bottom as the threshold from the observer
          const isActuallyScrolledPast = window.pageYOffset > this.headerBounds.bottom;

          // Only remove 'scrolled-past-header' if we are NOT actually scrolled past the threshold
          if (!isActuallyScrolledPast && !this.headerIsAlwaysSticky) {
             this.header.classList.remove('scrolled-past-header');
             // Also reset sticky/hidden/animate state if not actually scrolled and not always sticky
             this.reset(); // This method already handles removing these classes
          } else if (!isActuallyScrolledPast && this.headerIsAlwaysSticky) {
             // If always sticky and not scrolled, don't remove scrolled-past-header
             // or sticky classes as they are part of the always sticky state.
             // We only need to ensure the header isn't hidden.
              this.header.classList.remove('shopify-section-header-hidden');
          }
          // If isActuallyScrolledPast is true, the scroll logic will keep the class(es)
        };

        // Add event listeners to each found menu element
        this.navMenus.forEach(menu => {
          menu.addEventListener('mouseenter', this.handleMouseEnter);
          menu.addEventListener('mouseleave', this.handleMouseLeave);
        });
      }
      // --- End: Add Hover Logic ---

    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      // --- Start: Remove Hover Logic ---
      // Clean up event listeners when the element is removed from the DOM
      if (this.navMenus && this.navMenus.length > 0) {
        this.navMenus.forEach(menu => {
          menu.removeEventListener('mouseenter', this.handleMouseEnter);
          menu.removeEventListener('mouseleave', this.handleMouseLeave);
        });
      }
      // --- End: Remove Hover Logic ---
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        // Trigger a scroll check immediately after getting bounds
        // to ensure the state is correct if loaded past the header.
        this.onScroll();
        observer.disconnect();
      });

      // Observe a sentinel element placed just after the header, or the header itself
      // observing the header itself and using intersectionRect.bottom is common.
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrolledPastThreshold = scrollTop > this.headerBounds.bottom;
      const isAtTop = scrollTop <= this.headerBounds.top;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // --- Start: Logic for 'scrolled-past-header' and sticky/hidden/animate classes ---
      // The header should transition to the "scrolled past" appearance (often sticky/smaller)
      // if scrolled past the threshold OR if the menu is hovered.

      const shouldBeScrolledPast = isScrolledPastThreshold || this.isMenuHovered;

      if (shouldBeScrolledPast) {
           this.header.classList.add('scrolled-past-header');
           // Apply sticky state regardless of scroll direction if we *should* be scrolled past
           if (!this.headerIsAlwaysSticky) {
               this.header.classList.add('shopify-section-header-sticky');
               // Manage hidden/reveal only based on scroll direction if not hovered
               // If hovered, we probably want it revealed.
               if (!this.isMenuHovered) {
                   if (scrollTop > this.currentScrollTop && isScrolledPastThreshold) {
                      // Scrolling down past threshold
                      if (this.preventHide) return;
                       requestAnimationFrame(this.hide.bind(this));
                   } else if (scrollTop < this.currentScrollTop && isScrolledPastThreshold) {
                      // Scrolling up past threshold
                       if (!this.preventReveal) {
                           requestAnimationFrame(this.reveal.bind(this));
                       } else {
                           window.clearTimeout(this.isScrolling);
                           this.isScrolling = setTimeout(() => {
                             this.preventReveal = false;
                           }, 66);
                           requestAnimationFrame(this.hide.bind(this));
                       }
                   }
                } else {
                    // If hovered, ensure it's not hidden and potentially animated
                    this.header.classList.remove('shopify-section-header-hidden');
                    this.header.classList.add('animate'); // Add animate if needed for transition
                }
            } else {
               // If always sticky, we might still hide/reveal based on scroll direction
                if (!this.isMenuHovered) {
                   if (scrollTop > this.currentScrollTop && isScrolledPastThreshold) {
                      // Scrolling down past threshold
                       if (this.preventHide) return;
                       requestAnimationFrame(this.hide.bind(this));
                   } else if (scrollTop < this.currentScrollTop && isScrolledPastThreshold) {
                      // Scrolling up past threshold
                       if (!this.preventReveal) {
                           requestAnimationFrame(this.reveal.bind(this));
                       } else {
                           window.clearTimeout(this.isScrolling);
                           this.isScrolling = setTimeout(() => {
                             this.preventReveal = false;
                           }, 66);
                           requestAnimationFrame(this.hide.bind(this));
                       }
                   }
                } else {
                     // If always sticky and hovered, ensure not hidden
                     this.header.classList.remove('shopify-section-header-hidden');
                }
            }
      } else if (isAtTop && !this.isMenuHovered && !this.headerIsAlwaysSticky) {
        // If at the very top AND not hovered AND not always sticky
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this)); // Reset removes sticky/hidden/animate
      } else if (isAtTop && this.isMenuHovered && !this.headerIsAlwaysSticky) {
        // If at the very top BUT hovered, keep the scrolled-past-header state
         this.header.classList.add('scrolled-past-header');
         this.header.classList.add('shopify-section-header-sticky', 'animate');
         this.header.classList.remove('shopify-section-header-hidden');
      }
      // --- End: Logic for 'scrolled-past-header' and sticky/hidden/animate classes ---


      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return; // Always sticky headers don't hide completely based on scroll direction
      if (this.isMenuHovered) return; // Don't hide if the menu is currently hovered

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate'); // Remove animate when hidden
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // Always sticky headers manage reveal differently or not at all via scroll direction
      if (this.headerIsAlwaysSticky) return;
      // If hovered, reveal is handled by the onScroll/mouseenter logic
      if (this.isMenuHovered) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // Always sticky headers don't reset fully
      if (this.headerIsAlwaysSticky) {
        // Ensure it's not hidden if always sticky and reset is called
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }
      // If hovered, don't fully reset
      if (this.isMenuHovered) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) { // Check if searchModal exists
         this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
